<template>
  <div
    v-loading="loading"
    style="
      background: #f5f5f5;
      background-image: url('../../../static/img/Background4.jpg');
    "
  >
    <div class="father_div_bg">
      <div class="selectbox">
        <img src="../../../static/img/48.png" class="jiantou" />
        <span @click="navto('/Product')" class="cur">{{
          language == "zh" ? "产品中心" : "Products"
        }}</span>
        <span class="fenge">></span>
        <span
          class="cur"
          @click="navto('/ProductDetail?' + '&type1=' + type1_ID)"
          >{{ language == "zh" ? type1 : type1En }}</span
        >
        <span class="fenge" v-if="type2">></span>
        <span
          class="cur"
          v-if="type2"
          @click="
            navto('/ProductDetail?type2=' + type2_ID + '&type1=' + type1_ID)
          "
          >{{ language == "zh" ? type2 : type2En }}</span
        >
        <span class="fenge" v-if="type3">></span>
        <span
          class="cur"
          v-if="type3"
          @click="
            navto(
              '/ProductDetail?type2=' +
                type2_ID +
                '&type1=' +
                type1_ID +
                '&type3=' +
                type3_ID
            )
          "
          >{{ language == "zh" ? type3 : type3En }}</span
        >
        <transition
          appear
          name="animate__animated animate__bounce"
          enter-active-class="animate__fadeIn"
          leave-active-class="animated__fadeOut"
        >
          <div v-show="isShow" class="keyinput">
            <el-autocomplete
              class="inline-input"
              v-model="input"
              :fetch-suggestions="querySearch"
              :placeholder="language == 'zh' ? '请输入内容' : 'please input'"
              style="width: 300px"
              @select="handleSelect"
              :trigger-on-focus="false"
            ></el-autocomplete>
          </div>
        </transition>
        <!-- @click="isShow = !isShow" -->
        <img
          src="../../../static/img/5.png"
          class="sousuo"
          @click="isShow = !isShow"
        />
      </div>
      <el-row :gutter="25" class="product-menu">
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="left">
          <div class="menu">
            <div class="biaoti" v-if="!type3">
              {{ language == "zh" ? menu.label : menu.labelEn }}
            </div>
            <el-tree
              class="tree treeI treea"
              :icon-class="icon"
              :default-expand-all="true"
              :data="menuchild"
              :props="defaultProps"
              @node-click="handleNodeClick2"
              v-show="language == 'zh'"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span :class="node.disabled ? 'p_disabled' : 'p_abled'">{{
                  node.label
                }}</span>
              </span>
            </el-tree>
            <el-tree
              class="tree treeI treea"
              :icon-class="icon"
              node-key="label"
              :default-expand-all="true"
              :data="menuchild_"
              :props="defaultProps1"
              @node-click="handleNodeClick2"
              v-show="language == 'en'"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span :class="node.disabled ? 'p_disabled' : 'p_abled'">{{
                  node.label
                }}</span>
              </span>
            </el-tree>
            <div class="line" v-show="menu.state == 1"></div>
            <div class="line_empty" v-show="menu.state == 0"></div>
            <el-tree
              class="tree treeII"
              node-key="labelEn"
              :icon-class="icon"
              :default-expand-all="true"
              :data="menu1"
              :props="defaultProps"
              v-show="language == 'zh' && menu.state == 1"
              :render-content="renderContent"
              ref="chakong"
            ></el-tree>
            <el-tree
              class="tree treeII"
              node-key="labelEn"
              :icon-class="icon"
              :default-expand-all="true"
              :data="menu1_"
              :props="defaultProps1"
              :render-content="renderContent"
              v-show="language == 'en' && menu.state == 1"
              ref="chakongEn"
            ></el-tree>
            <el-tree
              class="tree treeIII"
              :icon-class="icon"
              node-key="labelEn"
              :default-expand-all="true"
              :data="menu2"
              :props="defaultProps"
              :render-content="renderContent"
              v-show="language == 'zh' && menu.state == 1"
              ref="liuliang"
            ></el-tree>
            <el-tree
              class="tree treeIII"
              :icon-class="icon"
              node-key="labelEn"
              :default-expand-all="true"
              :data="menu2_"
              :props="defaultProps1"
              :render-content="renderContent"
              v-show="language == 'en' && menu.state == 1"
              ref="liuliangEn"
            ></el-tree>
            <div class="del_div" v-show="menu.state == 1">
              <img
                v-show="menu.state == 1"
                src="../../../static/img/资源 52.png"
                @click="resetFliter()"
              />
            </div>
          </div>
          <div class="menu callus show_pc">
            <div class="text">
              {{ language == "zh" ? "联系我们" : "Contact us" }}
            </div>
            <div class="tel">
              <img src="../../../static/img/50.png" /> {{ contact.tel }}
            </div>
            <div class="email">
              <img src="../../../static/img/49.png" />{{ contact.email }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="right">
          <div class="tag_div">
            <el-tag
              v-for="(item, i) in cktag"
              :key="i"
              @close="handleClose(item, i, 0)"
              closable
              type="info"
            >
              {{ language == "zh" ? "插孔：" + item : "Cavity：" + item }}
            </el-tag>
            <el-tag
              v-for="(item, i) in lltag"
              :key="i"
              @close="handleClose(item, i, 1)"
              closable
              type="info"
            >
              {{
                language == "zh"
                  ? "流量（L/min）：" + item
                  : "Flow（L/min）：" + item
              }}
            </el-tag>
          </div>
          <div class="righttable">
            <el-row>
              <el-col
                class="tableheard"
                v-for="(item, i) in biaoti"
                :key="i"
                :span="item.span"
                ><p
                  @click="sort(item, i)"
                  :class="item.class"
                  v-show="state == item.state"
                >
                  {{ language == "zh" ? item.name : item.nameEn }}
                  <img :src="item.img" v-if="item.img" /></p
              ></el-col>
            </el-row>
            <el-divider class="divider_div"></el-divider>
            <div
              :class="[inx % 2 == 1 ? 'job_item_div2' : 'job_item_div']"
              v-for="(i, inx) in tableData"
              :key="inx"
              @click="rowClick(i)"
            >
              <el-row>
                <el-col :span="4" v-if="state == 1">
                  <div class="flex_div">
                    <img slot="reference" :src="i.symbol" class="pimg" />
                    <el-divider direction="vertical"></el-divider>
                  </div>
                </el-col>
                <el-col :span="7"
                  ><div class="flex_div">
                    <p class="start_p text-ellipsis" v-html="language == 'zh' ? i.key : i.keyEn">
                    </p>
                    <el-divider direction="vertical"></el-divider></div
                ></el-col>
                <el-col :span="5"
                  ><div class="flex_div">
                    <p class="center_p">{{ i.model }}</p>
                    <el-divider direction="vertical"></el-divider></div
                ></el-col>
                <el-col :span="4" v-if="state == 1"
                  ><div class="flex_div">
                    <p class="center_p">{{ i.cavity }}</p>
                    <el-divider direction="vertical"></el-divider></div
                ></el-col>
                <el-col :span="4" v-if="state == 1"
                  ><div class="flex_div">
                    <p class="center_p">{{ i.flow }}</p>
                  </div></el-col
                >
                <el-col :span="12" v-if="state == 0"
                  ><div class="flex_div">
                    <span class="end_p text-ellipsis" v-html="language == 'zh' ? i.description : i.descriptionEn">
                    </span>
                  </div></el-col
                >
              </el-row>
            </div>
            <div class="fenye" v-if="fenye">
              <el-button type="info" @click="llqb">{{
                language == "zh" ? "浏览全部" : "View all"
              }}</el-button>
              <img src="../../../static/img/62.png" @click="prev" />
              <span>{{ language == "zh" ? "页面" : "Page" }}</span>
              <span>
                <el-input
                  v-model="currentPage"
                  size="mini"
                  @keyup.enter.native="getInfo1"
                >
                </el-input> </span
              >/
              <span class="pageCount">{{ pageCount }}</span>
              <img src="../../../static/img/61.png" @click="next" />
            </div>
            <div class="fenye" v-else>
              <el-button type="primary" @click="llqb">{{
                language == "zh" ? "分页浏览" : "Tabbed Browsing"
              }}</el-button>
              <img src="../../../static/img/62.png" />
              <span>{{ language == "zh" ? "页面" : "Page" }}</span>
              <span>
                <el-input :disabled="true" v-model="currentPage" size="mini">
                </el-input> </span
              >/
              <span class="pageCount">{{ pageCount }}</span>
              <img src="../../../static/img/61.png" />
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="Mymenu callus show_phone">
          <div class="text">
            {{language=='zh'?'联系我们':'Contact us'}}
          </div>
          <div class="tel">
           <img src="../../../static/img/50.png" /> {{contact.tel}}
          </div>
          <div class="email">
            <img src="../../../static/img/49.png" />{{contact.email}}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "Product",
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      flow: [],
      loading: false,
      currentkey: null,
      currentkey1: null,
      contact: {},
      input: "",
      isShow: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      defaultProps1: {
        children: "children",
        label: "labelEn",
      },
      biaoti: [
        {
          span: "4",
          class: "img_p",
          state: 1,
          name: "原理图",
          nameEn: "Symbol",
        },
        {
          span: "7",
          class: "start_p",
          state: 1,
          name: "产品名称",
          nameEn: "Name",
          code: "key",
          img: "../../../static/img/58.png",
        },
        {
          span: "5",
          class: "center_p",
          state: 1,
          name: "型号",
          code: "model",
          nameEn: "Model",
          img: "../../../static/img/58.png",
        },
        {
          span: "7",
          class: "start_p",
          state: 0,
          name: "产品名称",
          nameEn: "Name",
          code: "key",
          img: "../../../static/img/58.png",
        },
        {
          span: "5",
          class: "center_p",
          state: 0,
          name: "型号",
          code: "model",
          nameEn: "Model",
          img: "../../../static/img/58.png",
        },
        {
          span: "4",
          class: "center_p",
          state: 1,
          name: "插孔",
          code: "cavity",
          nameEn: "Cavity",
          img: "../../../static/img/58.png",
        },
        {
          span: "4",
          class: "center_p",
          state: 1,
          code: "flow",
          name: "流量(L/min)",
          nameEn: "Flow(L/min)",
          img: "../../../static/img/58.png",
        },
        {
          span: "12",
          class: "end_p",
          state: 0,
          name: "产品描述",
          nameEn: "description",
        },
      ],
      fenye: true,
      pageCount: 0,
      currentPage: 1,
      lltag: [],
      cktag: [],
      icon: "el-icon-plus",
      menu: {},
      menuchild: [],
      menuchild_: [],
      menu1: [
        {
          label: "插孔",
          labelEn: "Cavity",
          id: "1",
          disabled: false,
          children: [
            {
              label: "08",
              labelEn: "08",
              pName: "插孔",
              choose: false,
              pNameEn: "Cavity",
            },
            {
              label: "10",
              labelEn: "10",
              pName: "插孔",
              choose: false,
              pNameEn: "Cavity",
            },
            {
              label: "12",
              labelEn: "12",
              pName: "插孔",
              choose: false,
              pNameEn: "Cavity",
            },
            {
              label: "16",
              labelEn: "16",
              pName: "插孔",
              choose: false,
              pNameEn: "Cavity",
            },
          ],
        },
      ],
      orderBy: "",
      sidx: "",
      menu2_: [],
      menu1_: [],
      menu2: [
        {
          label: "流量(L/min)",
          labelEn: "Flow(L/min)",
          id: "1",
          disabled: false,
          children: [
            {
              label: "10以下",
              pName: "流量",
              labelEn: "Below 10",
              pNameEn: "Flow",
              flowLow: 10,
              code: "1",
              choose: false,
              flowHigh: "",
            },
            {
              label: "10-50",
              labelEn: "10-50",
              pName: "流量",
              code: "2",
              pNameEn: "Flow",
              flowLow: 10,
              choose: false,
              flowHigh: 50,
            },
            {
              label: "50-100",
              labelEn: "50-100",
              pName: "流量",
              code: "3",
              pNameEn: "Flow",
              choose: false,
              flowLow: 10,
              flowHigh: "",
            },
            {
              label: "100-150",
              labelEn: "100-150",
              pName: "流量",
              pNameEn: "Flow",
              code: "4",
              choose: false,
              flowLow: 100,
              flowHigh: 150,
            },
            {
              label: "150-200",
              labelEn: "150-200",
              pName: "流量",
              pNameEn: "Flow",
              choose: false,
              code: "5",
              flowLow: 150,
              flowHigh: 200,
            },
            {
              label: "200以上",
              labelEn: "Over 200",
              pName: "流量",
              choose: false,
              code: "6",
              pNameEn: "Flow",
              flowLow: "",
              flowHigh: 200,
            },
          ],
        },
      ],
      limit: 10,
      tableData: [],
      state: 1,
      type1_ID: "",
      type2_ID: "",
      type3_ID: "",
      type1: "",
      type1En: "",
      type2: "",
      type2En: "",
      type3: "",
      type3En: "",
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.input = "";
      this.clearTable();
      this.loading = true;
      this.menu1_ = this.menu1;
      this.menu2_ = this.menu2;
      console.log(to);
      console.log(from);
      if (to.fullPath.indexOf("ProductDetail") >= 0) {
        // console.log(to.fullPath.indexOf('ProductDetail') >= 0)
        // console.log(from.fullPath.indexOf('ProductIntroduce') >= 0)
        //如果是从产品详情页返回则不重置排序
        // if(!(from.fullPath.indexOf('ProductIntroduce') >= 0)){
        let imgbox = [
          "../../../static/img/58.png",
          "../../../static/img/56.png",
          "../../../static/img/55.png",
        ];
        // this.biaoti.map((t,inx)=>{
        //     if(t.class.indexOf('blue')){
        //       t.class=t.class.replace('blue','')
        //       this.$set(this.biaoti[inx],'img',imgbox[0])
        //     }
        // })
        // }
        this.justFliter();
        this.getInfo();
        this.getInfo2();
      }
      if (this.GetQueryString("isshow")) {
        this.isShow = true;
      }
      // this.$parent.hideSearch = from.fullPath.indexOf('Product') >= 0?true:false
    },
  },
  mounted() {
    this.menu1_ = this.menu1;
    this.menu2_ = this.menu2;
    this.getInfo();
    this.getInfo2();
    if (this.GetQueryString("isshow")) {
      this.isShow = true;
    }
  },
  methods: {
    clearTable() {
      console.log("clearTable");
      this.tableData.length = 0;
      this.tableData = [];
    },
    querySearch(queryString, cb) {
      let params = {
        key: this.input,
        page: 1,
        limit: 999,
      };
      this.$http
        .get("/hdbs/api/product/list", {
          params,
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              let restaurant = [];
              let temp_arr = [];
              response.data.data.list.map((data) => {
                var typeNameList = data.typeName.split("/");
                var typeNameListEn = data.typeNameEn.split("/");
                console.log(typeNameList);
                if (data.type1) {
                  let d = typeNameList[0];
                  if (this.language == "en") {
                    d = typeNameListEn[0];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({ value: d, code: 1, type1: data.type1 });
                  }
                }
                if (data.type2) {
                  let d = typeNameList[0] + ">" + typeNameList[1];
                  if (this.language == "en") {
                    d = typeNameListEn[0] + ">" + typeNameListEn[1];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({
                      value: d,
                      code: 2,
                      type1: data.type1,
                      type2: data.type2,
                    });
                  }
                }
                if (data.type3) {
                  let d =
                    typeNameList[0] +
                    ">" +
                    typeNameList[1] +
                    ">" +
                    typeNameList[2];
                  if (this.language == "en") {
                    d =
                      typeNameListEn[0] +
                      ">" +
                      typeNameListEn[1] +
                      ">" +
                      typeNameListEn[2];
                  }
                  if (temp_arr.indexOf(d) == -1) {
                    temp_arr.push(d);
                    restaurant.push({
                      value: d,
                      code: 3,
                      type1: data.type1,
                      type2: data.type2,
                      type3: data.type3,
                    });
                  }
                }
                let d = data.key + "(" + data.model + ")";
                if (this.language == "en") {
                  d = data.keyEn + "(" + data.model + ")";
                }
                restaurant.push({
                  value: d,
                  code: 4,
                  id: data.id,
                });
              });
              // 调用 callback 返回建议列表的数据
              cb(restaurant);
            }
          }.bind(this)
        );
    },
    renderContent(h, { node, data, store }) {
      console.log("data.choose==" + data.choose);
      // console.log(h)
      // console.log(node)
      // console.log(data)
      if (data.choose) {
        return (
          <span class="custom-tree-node" on-click={() => this.append(data)}>
            <span class="el-tree-node__label active">{node.label}</span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <span
              class="el-tree-node__label"
              on-click={() => this.append(data)}
            >
              {node.label}
            </span>
          </span>
        );
      }
    },
    append(data) {
      console.log(data);
      data.choose = true;
      if (data.choose) {
        if (data.id == "1") {
          return false;
        }
        if (data.pName == "插孔") {
          let label = this.language == "zh" ? data.label : data.labelEn;
          if (this.cktag.indexOf(label) < 0) {
            this.cktag.push(label);
          } else {
            data.choose = false;
            this.cktag.forEach((item, index, arr) => {
              if (item == label) {
                this.cktag.splice(index, 1);
              }
            });
          }
        } else {
          let label = this.language == "zh" ? data.label : data.labelEn;
          if (this.lltag.indexOf(label) < 0) {
            this.lltag.push(label);
            this.flow.push(data.code);
          } else {
            data.choose = false;
            this.lltag.forEach((item, index, arr) => {
              if (item == label) {
                this.lltag.splice(index, 1);
              }
            });
            this.flow.forEach((item, index, arr) => {
              if (item == data.code) {
                this.flow.splice(index, 1);
              }
            });
          }
        }
      }
      this.getInfo1();
    },
    sort(item, index) {
      // console.log(item)
      // console.log(index)
      let imgbox = [
        "../../../static/img/58.png",
        "../../../static/img/56.png",
        "../../../static/img/55.png",
      ];
      this.biaoti.map((t, inx) => {
        // console.log(t)
        // console.log(inx)
        if (inx != index) {
          t.class = t.class.replace("blue", "");
          if (this.biaoti[inx].img) {
            this.$set(this.biaoti[inx], "img", imgbox[0]);
          }
        }
      });

      for (const i in imgbox) {
        if (item.img == imgbox[Number(i)]) {
          item.img = Number(i) == 2 ? imgbox[0] : imgbox[Number(i) + 1];
          if (Number(i) + 1 == 1) {
            this.orderBy = "asc";
            this.sidx = item.code;
            if (item.class.indexOf("blue") < 0) {
              item.class = item.class + " blue";
            }
          } else if (Number(i) + 1 == 2) {
            this.orderBy = "desc";
            this.sidx = item.code;
            if (item.class.indexOf("blue") < 0) {
              item.class = item.calss + " blue";
            }
            // this.tableData = this.tableData.sort(
            //   (a, b) => b[item.code] - a[item.code]
            // );
          } else {
            this.orderBy = "";
            this.sidx = "";
            if (item.class.indexOf("blue") >= 0) {
              item.class = item.class.replace("blue", "");
            }
          }
          this.getInfo1();
          return false;
        }
      }
      this.getInfo2();
    },
    handleSelect(item) {
      if (item.code == 4) {
        this.$router.push("/ProductIntroduce?id=" + item.id);
      } else if (item.code == 1) {
        this.$router.push("/ProductDetail?type1=" + item.type1);
      } else if (item.code == 2) {
        this.$router.push(
          "/ProductDetail?type1=" + item.type1 + "&type2=" + item.type2
        );
      } else if (item.code == 3) {
        this.$router.push(
          "/ProductDetail?type1=" +
            item.type1 +
            "&type2=" +
            item.type2 +
            "&type3=" +
            item.type3
        );
      }
    },
    justFliter(){
      this.currentPage=1;
      this.cktag = [];
      this.menu1[0].children.map((r) => (r.choose = false));
      this.menu1_[0].children.map((r) => (r.choose = false));
      this.lltag = [];
      this.flow = [];
      this.menu2[0].children.map((r) => (r.choose = false));
      this.menu2_[0].children.map((r) => (r.choose = false));
    },
    resetFliter() {
      this.cktag = [];
      this.menu1[0].children.map((r) => (r.choose = false));
      this.menu1_[0].children.map((r) => (r.choose = false));
      this.lltag = [];
      this.flow = [];
      this.menu2[0].children.map((r) => (r.choose = false));
      this.menu2_[0].children.map((r) => (r.choose = false));
      this.getInfo1();
    },
    getInfo2() {
      this.$http.get("/hdbs/api/contacts/company", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.contact = response.data.data[0];
          }
        }.bind(this)
      );
    },
    prev() {
      if (this.currentPage == 1) {
        return;
      }
      this.currentPage--;
      this.getInfo1();
    },
    next() {
      if (this.currentPage == this.pageCount) {
        return;
      }
      this.currentPage++;
      this.getInfo1();
    },
    llqb() {
      this.fenye = !this.fenye;
      if (!this.fenye) {
        this.limit = 999;
        this.currentPage = 1;
      } else {
        this.limit = 10;
      }
      this.getInfo1();
    },
    navto(url) {
      this.$router.push(url);
    },
    getInfo() {
      this.$http.get("/hdbs/api/product/type/tree", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            let type1 = this.GetQueryString("type1");
            let type2 = this.GetQueryString("type2");
            let type3 = this.GetQueryString("type3");
            this.type1_ID = type1;
            this.type2_ID = type2;
            this.type3_ID = type3;
            let menu = response.data.data.filter((x) => {
              return x.value == type1;
            })[0];
            this.type1 = menu.label;
            this.type1En = menu.labelEn;
            if (type2 != undefined && type2 != "null") {
              let menu1 = menu.children.filter((x) => {
                return x.value == type2;
              })[0];
              this.type2 = menu1.label;
              this.type2En = menu1.labelEn;
              this.menu = menu1;
              if (type3 != undefined && type3 != "null") {
                let menu2 = menu1.children.filter((x) => {
                  return x.value == type3;
                })[0];
                this.type3 = menu2.label;
                this.type3En = menu2.labelEn;
                this.menuchild = [menu2];
                this.menuchild_ = [menu2];
              } else {
                this.menu = menu.children.filter((x) => {
                  return x.value == type2;
                })[0];

                this.type3 = "";
                this.type3En = "";
                this.menuchild = this.menu.children || [];
                this.menuchild_ = this.menu.children || [];
              }
              // this.type2 = this.menu.label
              // this.type2En = this.menu.labelEn
            } else {
              this.menu = menu;
              this.menuchild = this.menu.children || [];
              this.menuchild_ = this.menu.children || [];
              this.type2 = "";
              this.type2En = "";
              this.type3 = "";
              this.type3En = "";
            }
            this.menuchild.map((r) => {
              // r.level = 2
              if (r.num == 0) {
                r.disabled = true;
              }
              if (!r.children) {
                return;
              }
              r.children.map((c) => {
                // c.level = 3
                if (c.num == 0) {
                  c.disabled = true;
                  if (c.children) {
                    c.children.map((a) => {
                      a.disabled = true;
                    });
                  }
                }
              });
            });
            this.getInfo1();
          }
        }.bind(this)
      );
    },
    getInfo1() {
      let params = {
        key: this.input,
        pdType: this.type3_ID ? this.type3_ID : this.type2_ID? this.type2_ID:this.type1_ID,
        page: this.currentPage,
        limit: this.limit,
        cavity: this.cktag.toString(),
        flow: this.flow.toString(),
        sidx: this.sidx,
        orderBy: this.orderBy,
      };
      for (const i in params) {
        if (params[i] == "") {
          delete params[i];
        }
      }
      this.clearTable();
      this.$http
        .get("/hdbs/api/product/list", {
          params,
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.state = this.menu.state;
              this.tableData = response.data.data.list;
              this.pageCount = response.data.data.totalPage;
              let that = this;
              // setTimeout(function () {
              //   that.loading = false;
              // }, 500);
              that.loading = false;
            }
          }.bind(this)
        );
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    },
    handleClose(item, i, tag) {
      if (tag == 0) {
        this.cktag.splice(i, 1);
        this.menu1[0].children.map((r, inx) => {
          if (r.label == item) {
            this.$set(this.menu1[0].children[inx], "choose", false);
          }
        });
        this.menu1_[0].children.map((r, inx) => {
          if (r.label == item) {
            this.$set(this.menu1_[0].children[inx], "choose", false);
          }
        });
      } else {
        this.lltag.splice(i, 1);
        this.flow.splice(i, 1);
        this.menu2[0].children.map((r, inx) => {
          if (r.label == item) {
            this.$set(this.menu2[0].children[inx], "choose", false);
          }
        });
        this.menu2_[0].children.map((r, inx) => {
          if (r.label == item) {
            this.$set(this.menu2_[0].children[inx], "choose", false);
          }
        });
      }

      // this.menu1[0].choose = false
      this.getInfo1();
    },
    handleNodeClick2(data) {
      let type3 = this.GetQueryString("type3");
      let type2 = this.GetQueryString("type2");
      let type1 = this.GetQueryString("type1");
      console.log(data);
      console.log(type1);
      console.log(type2);
      console.log(type3);
      if (data.num != 0) {
        //如果分类下没有产品则不可点击

        if (data.level == 3) {
          this.$router.push(
            "/ProductDetail?type1=" +
              type1 +
              "&type2=" +
              data.parentId +
              "&type3=" +
              data.value
          );
        } else if (data.level == 2) {
          // if(data.children==null||data.children==undefined){
          //   this.$router.push('/ProductDetail?type1='+type1+'&type2='+data.parentId+'&type3='+data.value);
          // }else{
          this.$router.push(
            "/ProductDetail?type1=" + data.parentId + "&type2=" + data.value
          );
          // }
        }
      }
    },
    rowClick(row) {
      this.$router.push("/ProductIntroduce?id=" + row.id);
    },
  },
};
</script>
<style lang="stylus" scoped>
.text-ellipsis{
  font-family:Regular;
  font-size:1.7rem;
    overflow: hidden;
    width: 100%;
    display: -webkit-box !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
}
/deep/ .el-loading-mask {
  background-color: rgba(255, 255, 255, 0.95);
}
.Mymenu{
  width: 100%;
  padding: 3.5rem 2rem;
  background: #fff;
  border-radius: 6px;
  font-size: 1.7rem;
  margin-bottom: 3rem;
  box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
    .biaoti{
      color: var(--mainBlue);
      margin-bottom: 3rem;
      font-size: 2.7rem;
      margin-left: 2.5rem;
      font-family: Demibold;
    }
}
.show_pc {
  display: block;
}
.show_phone {
  display: none;
}
.selectbox {
  background: #fff;
  border-radius: 6px;
  margin: 4vh 0;
  padding: 2rem;
  position: relative;
  font-family: Regular;
  display: flex;
  font-size: 1.7rem;
  align-items: center;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
  color: var(--mainGary);

  .cur {
    cursor: pointer;
  }

  .cur:hover {
    color: #024580;
  }

  .fenge {
    padding: 0 10px;
  }

  .jiantou {
    width: 6px;
    margin-right: 20px;
  }

  .sousuo {
    width: 15px;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  .keyinput {
    position: absolute;
    right: 10px;
  }
}

.callus {
  margin-top: 3rem;
  padding: 3.5rem 2rem;
  font-size: 1.7rem;

  .text {
    color: #024580;
    margin-bottom: 2rem;
    margin-left: 2.5rem;
  }

  .tel {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }

  .email {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }
}

.product-menu {
  margin: 0 !important;

  .left {
    padding-left: 0 !important;

    .menu {
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
      margin-bottom: 25px;

      .biaoti {
        color: #024580;
        font-family: Regular;
        padding: 1vw 0 0 1vw;
        font-size: 1.7rem;
      }

      .line {
        margin-top: 1rem;
        width: 80%;
        height: 1px;
        margin-left: 10%;
        background: #e4e7ed;
      }

      .line_empty {
        margin-top: 2rem;
        width: 80%;
        height: 1px;
        margin-left: 10%;
        background: #ffffff00;
      }

      .tree {
        border-radius: 6px;
        padding: 1vw 1vw 0 1vw;
        font-family: Regular;

        /deep/.el-tree-node__content {
          margin: 10px 0;
        }
      }

      .treeIII {
        padding: 0 1vw 1vw 1vw;
      }
    }
  }

  .right {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
    margin-bottom: 6vh;

    .righttable {
      padding: 2vw;

      .producttable {
        // margin: 2vw
        .pimg {
          width: 8vw;
        }
      }
    }

    .fenye {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 20px 0;

      img {
        width: 6px;
        margin: 0 10px;
        cursor: pointer;
      }

      /deep/ .el-input__inner {
        width: 20px;
        padding: 0;
        text-align: center;
        margin: 0 5px;
      }

      .pageCount {
        margin: 0 5px;
      }
    }
  }

  .tag_div {
    margin-top: 3rem;
    padding: 0 2vw;
  }

  .el-tag.el-tag--info {
    background-color: var(--garyE2);
    border-color: var(--garyE2);
    color: var(--mainGary);
  }

  .del_div {
    display: flex;
    justify-content: flex-end;
    padding: 0 3rem 3rem 0;

    img {
      width: 1.5rem;
    }
  }

  .col_title {
    font-family: Regular;
  }
}

/deep/ .el-tree-node__label {
  font-size: 1.7rem;
}

.flex_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 16rem;

  p {
    margin-bottom: 0;
  }

  .pimg {
    width: 99%;
    height: 99%;
    object-fit: contain;
  }
}

.img_p {
  user-select: none;
  text-align: left;
  margin-left: 2rem;
  display: inline-block;
  vertical-align: middle;
  display: flex;
  // cursor: pointer;
  align-items: center;

  img {
    height: 1.5rem;
    margin-left: 0.5em;
  }
}

.start_p {
  user-select: none;
  text-align: left;
  margin-left: 2rem;
  display: inline-block;
  vertical-align: middle;
  display: flex;
  cursor: pointer;
  align-items: center;

  img {
    height: 1.5rem;
    margin-left: 0.5em;
  }
}

.tableheard .start_p:hover {
  font-family: Demibold;
}

.tableheard .center_p:hover {
  font-family: Demibold;
}

.center_p {
  user-select: none;
  cursor: pointer;
  width: 100%;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 1.5rem;
    margin-left: 0.5em;
  }
}

.center_p.blue {
  color: var(--mainBlue);
  font-family: Demibold;
}

.start_p.blue {
  color: var(--mainBlue);
  font-family: Demibold;
}

.end_p {
  user-select: none;
  padding: 0 2rem;
  margin-right: 1rem;
  display: inline-block;
  vertical-align: middle;
}

.end_p.blue {
  color: var(--mainBlue);
  font-family: Demibold;
}

.el-divider--vertical {
  margin: 0;
  height: 80%;
  background-color: var(--garyD5);
  font-family: Demibold;
}

.job_item_div {
  cursor: pointer;
  background-color: var(--garyE2);
  border-radius: 6px;
  margin-bottom: 2rem;
}

.job_item_div .el-row:hover {
  background-color: #fff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
  border-radius: 6px;

  .start_p, .center_p, .end_p {
    color: var(--mainBlue);
    font-family: Demibold;
  }
}

.job_item_div2 {
  cursor: pointer;
  background-color: var(--garyEF);
  border-radius: 6px;
  margin-bottom: 2rem;
}

.job_item_div2 .el-row:hover {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);

  .start_p, .center_p, .end_p {
    color: var(--mainBlue);
    font-family: Demibold;
  }
}

.divider_div {
  margin-top: 0;
}

/deep/ .el-tree-node__label.active {
  color: #024580;
  font-family: 'Bold';
}

.father_div_bg {
  padding: 0 20rem;
  border-radius: 6px;
  height: 100%;
}

/deep/ .el-tree__empty-block {
  display: none;
}

.p_disabled {
  cursor: not-allowed;
  font-size: 1.7rem;
}

.p_abled {
  cursor: pointer;
  font-size: 1.7rem;
}

.p_abled:hover {
  cursor: pointer;
  font-size: 1.7rem;
  color: var(--mainBlue);
  font-family: Demibold;
}

@media screen and (max-width: 1400px) {
  .father_div_bg {
    padding: 0 1rem;
  }
}
@media screen and (max-width: 1000px) {
  
  .selectbox{
    margin-top:-4vh;
  }
  .show_pc {
    display: none;
  }
  .show_phone {
    display: block;
  }
  .product-menu .left{
    margin-top:0;
    padding-right: 0 !important;
  }
  .product-menu .right{
    margin-top:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductI.vue